import * as constants from './constants';

export const initialState = {
  loading: false,
  list: {}, // все платежи с пагинацией
  item: {},
  error: undefined,
  policyPayments: [], // платежи конкретного полиса
  uploading: false, // флаг процесса загрузки инвойса
  invoice: undefined, // загруженный файл счёта
};

const paymentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.RESET_ERROR:
    case constants.FETCH_PAYMENTS:
    case constants.FETCH_PAYMENTS_FAIL:
    case constants.FETCH_PAYMENTS_SUCCESS:
    case constants.FETCH_PAYMENT:
    case constants.FETCH_PAYMENT_FAIL:
    case constants.FETCH_PAYMENT_SUCCESS:
    case constants.FETCH_POLICY_PAYMENTS:
    case constants.FETCH_POLICY_PAYMENTS_FAIL:
    case constants.FETCH_POLICY_PAYMENTS_SUCCESS:
    case constants.CREATE_PAYMENT:
    case constants.CREATE_PAYMENT_FAIL:
    case constants.CREATE_PAYMENT_SUCCESS:
    case constants.UPDATE_PAYMENT:
    case constants.UPDATE_PAYMENT_FAIL:
    case constants.UPDATE_PAYMENT_SUCCESS:
    case constants.DELETE_PAYMENT:
    case constants.DELETE_PAYMENT_FAIL:
    case constants.DELETE_PAYMENT_SUCCESS:
    case constants.UPLOAD_INVOICE:
    case constants.UPLOAD_INVOICE_FAIL:
    case constants.UPLOAD_INVOICE_SUCCESS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default paymentsReducer;
